var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimeTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_738_529)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_738_529",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_738_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7101 3H20.7559L14.1024 10.6238L21.9306 20.9999H15.802L10.9984 14.7082L5.50821 20.9999H2.45953L9.57549 12.8426L2.0694 3.00142H8.35403L12.6894 8.75122L17.7101 3ZM16.639 19.1727H18.3272L7.43191 4.73218H5.62171L16.639 19.1727Z",
    fill: "url(#paint0_linear_738_529)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_738_529",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 20.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009761"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_738_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeTwitter);
export default __webpack_public_path__ + "static/media/prime_twitter.c7901a891b8ab659b1a2cc0905105664.svg";
export { ForwardRef as ReactComponent };